<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-toolbar class="md-success">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <devices-menu @on-selected="onSelectedDevice"></devices-menu>
            </div>
          </div>
        </md-toolbar>
        <br />
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-empty-state
          v-show="showEmpty"
          md-icon="check_box_outline_blank"
          :md-label="$lang.titles.no_test_was_performed"
          :md-description="$lang.messages.if_want_testing_go_to_section_tesing"
        ></md-empty-state>
      </div>

      <div class="md-layout-item md-size-100" v-show="!showEmpty">
        <tabs
          :tab-name="testNames"
          :tab-icon="testIcons"
          :tab-color="testStatus"
          flex-column
          nav-pills-icons
        >
          <template
            v-for="(testResult, testResultIndex) in testResults"
            :slot="'tab-pane-'+(testResultIndex + 1)"
          >
            <md-card v-for="(testCase, testCaseIndex) in testResult.test" :key="testCaseIndex">
              <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                  <md-icon>score</md-icon>
                </div>
                <h4 class="title">{{$lang.titles.test_case}} {{testCase.ID + 1}}</h4>
              </md-card-header>
              <md-card-content>
                <test-case-table :tableData="testCase.results"></test-case-table>
              </md-card-content>
            </md-card>

            <md-card :key="testResultIndex + 100">
              <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                  <md-icon>insert_chart_outlined</md-icon>
                </div>
                <h4 class="title">{{$lang.titles.relative_error_chart}}</h4>
              </md-card-header>
              <md-card-content>
                <test-case-chart :chartData="formatDataForChart(testResult)"></test-case-chart>
              </md-card-content>
            </md-card>
          </template>
        </tabs>
      </div>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import DevicesMenu from "./components/DevicesMenu";
import TestCaseTable from "./components/TestCaseTable";
import TestCaseChart from "./components/TestCaseChart";

import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getUserToken } from "@/storage/memoryStorage";
import { Tabs } from "@/components";
import { format } from "date-fns";

export default {
  components: {
    DevicesMenu,
    Tabs,
    "snack-bar": snackBar,
    TestCaseTable,
    TestCaseChart
  },

  data() {
    return {
      testResults: [],
      testStatus: [],
      testIcons: [],
      testNames: [],
      showEmpty: false
    };
  },

  created() {
    this.$store.commit("setLoading", true);
  },

  methods: {
    onSelectedDevice(device) {
      if (device.token) {
        this.testNames = [];
        this.testIcons = [];
        this.testStatus = [];
        this.testResults = [];
        this.getTestResults(device.token);
      } else {
        this.showEmpty = true;
        this.$store.commit("setLoading", false);
      }
    },

    getTestResults(deviceToken) {
      this.$store.commit("setLoading", true);
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applications/accutest/results",
        data: {
          device_token: deviceToken,
          user_token: getUserToken(),
          order: "DESC"
        },
        withCredentials: true
      })
        .then(response => {
          this.showEmpty = false;

          response.data.data.forEach(element => {
            this.testNames.push(
              format(element.timestamp * 1000, "DD-MM-YYYY HH:mm:ss")
            );

            this.testResults.push(element);

            if (element.status === "SUCCESS") {
              this.testStatus.push("success");
              this.testIcons.push("check");
            } else {
              this.testStatus.push("danger");
              this.testIcons.push("close");
            }
          });

          this.$nextTick(() => {
            this.$store.commit("setLoading", false);
          });
        })
        .catch(error => {
          this.showEmpty = true;
          this.$store.commit("setLoading", false);
          if (error.response) {
            if (error.response.data.code !== 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    formatDataForChart(data) {
      let response = [];

      data.test.forEach((testCase, testCaseIndex2) => {
        testCase.results.forEach(result => {
          let testCaseIndex = response.findIndex(
            el => el.name === result.testCase
          );

          if (testCaseIndex == -1) {
            testCaseIndex =
              response.push({
                name: result.testCase,
                data: []
              }) - 1;
          }

          let value = result.relative_error;
          if (result.absolute_error < 0) {
            value = value * -1;
          }
          response[testCaseIndex].data.push([testCaseIndex2 + 1, value]);
        });
      });

      return response;
    }
  }
};
</script>

<style scoped>
</style>